import React from 'react';
import { SHOP_URL, EMPTY_IMAGE_URL } from '../../../utils/constants';
import { showsInstallIcon, showsCratingIcon } from '../../../utils/constants';
import { InstallIcon, PalletBoxIcon } from '../../../utils/icons';

/**
 * ProductImage component - renders an image with optional link wrapper
 * @param {Object} props
 * @param {boolean} props.canClick - Whether the image should be clickable
 * @param {string} props.handle - Product handle for the URL
 * @param {string} [props.src] - Image source URL (uses empty image if not provided)
 * @param {string} props.alt - Image alt text
 * @param {string} [props.variantId] - Optional variant ID for the URL
 * @param {string} [props.className] - Optional className for the wrapper
 * @param {string} [props.productType] - Product type; install/fees show InstallIcon
 */
function ProductImage({ canClick, handle, src, alt, variantId, className = 'aspect-ratio aspect-ratio--square', productType, isFulfilled=false }) {
  if (showsInstallIcon(productType)) {
    return (
      <div className={`${className} item-image--install`}>
        <InstallIcon
          className="product-image__install-icon"
          strokeColor="#b1b3b5"
          strokeWidth={16}
          isFulfilled={isFulfilled}
        />
      </div>
    );
  }

  if (showsCratingIcon(productType)) {
    return (
      <div className={`${className} item-image--pallet-box`}>
        <PalletBoxIcon
          className="product-image__pallet-box-icon"
          strokeColor="#b1b3b5"
          strokeWidth={16}
          isFulfilled={isFulfilled}
        />
      </div>
    );
  }
  const imageSrc = src || EMPTY_IMAGE_URL;
  const imageAlt = src ? alt : 'Empty image';
  const wrapperClassName = src ? className : `${className} item-image--empty`;
  // const imageSrcWithWidth = src ? `${src}?width=200&height=200&crop=center` : EMPTY_IMAGE_URL;
  
  const imageElement = <img src={imageSrc} alt={imageAlt} />;
  
  if (canClick && src) {
    const url = variantId 
      ? `${SHOP_URL}/products/${handle}?variant=${variantId}`
      : `${SHOP_URL}/products/${handle}`;
    
    return (
      <a className={wrapperClassName} href={url} target="_blank" rel="noopener noreferrer">
        {imageElement}
      </a>
    );
  }
  
  return (
    <div className={wrapperClassName}>
      {imageElement}
    </div>
  );
}

export default ProductImage;
